<div class="meal-card" [class.no-hover]="meal.isAdded" (mouseenter)="mouseEnter(meal)" (mouseleave)="mouseLeave(meal)">
    <div class="image-container" (click)="showMealInPopup()">
        <img class="meal-image" [src]="meal.photo_path" />
        <div class="labels-box" *ngIf="meal.labels && meal.labels.length > 0">
            <div *ngFor="let label of meal.labels" class="label-item">
                <span [style.background-color]="label?.color">
                    <img [src]="label.icon" class="mr-2" *ngIf="label.icon"/>
                    {{ label.name }}
                </span>
            </div>
        </div>
    </div>
    <div class="content" >
        <div (click)="showMealInPopup()" style="width: 100%;">
            <div class="main-content">
                <div class="text-section">
                    <div class="title-section">
                        <div class="title-content">
                            <div class="title">{{meal.name}}</div>
                            <div class="description-container">
                                <div class="description-text">{{ getMealDescription(meal)}}
                                    <span class="more-button" *ngIf="!meal.isAdded && !meal.show_nutrients">
                                        <span class="more-text">more></span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="nutrition-section" *ngIf="!hideNutrition && !meal.isAdded && meal.show_nutrients && !isCurrentMenu" [@fade_obj]>
                <div class="nutrition-container">
                    <div class="nutrition-row">
                        <div class="nutrition-items">
                            <div class="nutrition-item calories">
                                <div class="nutrition-label">Calories</div>
                                <div class="nutrition-value"><span class="value">{{ meal.energyKcal }}</span><span class="unit"> kcal</span></div>
                            </div>
                            <div class="nutrition-item">
                                <div class="nutrition-label">Protein</div>
                                <div class="nutrition-value"><span class="value">{{ meal.protein }} </span><span class="unit">gr</span></div>
                            </div>
                            <div class="nutrition-item fats">
                                <div class="nutrition-label">Fats</div>
                                <div class="nutrition-value"><span class="value">{{ meal.fat }} </span><span class="unit">gr</span></div>
                            </div>
                            <div class="nutrition-item">
                                <div class="nutrition-label">Carbs</div>
                                <div class="nutrition-value"><span class="value">{{ meal.availableCarbohydrate }} </span><span class="unit">gr</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="" *ngIf="hideNutrition || meal.isAdded || (!meal.isAdded && !meal.show_nutrients)" [@fade_obj]>
            <span class="allergies-label">Allergies</span>
            <i class="pi pi-info-circle" style="font-size: 0.8rem;margin-left: 0.5rem;cursor: pointer; font-weight: bold;" [pTooltip]="meal.alergies" tooltipPosition="top" placeholder="Top"></i>
        </div>

        <ng-container *ngTemplateOutlet="addRemoveMealButtons"></ng-container>
        
        
    </div>
</div>



<p-dialog [draggable]="false"
          [resizable]="false"
          [modal]="true"
          [closable]="true"
          [breakpoints]="{ '700px': '600px'}"
          [style]="{ width: '500px' }" 
          [(visible)]="mealPopUpVisibility"
          [blockScroll]="true"
          styleClass="meal-card-dialog"
          (onHide)="hideMealInPopup();">
    <ng-template pTemplate="header">
        <div class="image-container">
            <img class="meal-image" [src]="meal.photo_path">
        </div>
    </ng-template>
    <div class="fm-rubik meal">
        
        <div class="mt-3 web-left meal-title">
            {{meal.name}}
        </div>
        <div class="web-left mt-2 meal-description">
            <div>
                <span>{{ meal.description }}</span>
            </div>
            <div class="mt-2">
                <span class="meal-title" style="font-size: 14px;">Allergens:</span>
                <span> {{meal.alergies}}</span>
            </div>
            <div class="mt-2">
                <span class="meal-title" style="font-size: 14px;">Ingredients:</span>
                <span>
                    <div [innerHTML]="meal.quid" style="max-height: 130px; overflow-y: scroll;"></div>
                </span>
            </div>
            <div class="mt-2 fm-rubik w-100 d-flex" *ngIf="!isCurrentMenu">
                <div class="d-flex w-100">
                    <div class="meal-detail">
                        <span>Calories:</span>
                        <br />
                        <span class="meal-detail-font">
                            {{ meal.energyKcal }}
                            <span class="meal-detail-font-measure">Kcal</span>
                        </span>
                    </div>
                    <div class="meal-detail">
                        <span>Protein:</span>
                        <br />
                        <span class="meal-detail-font">
                            {{ meal.protein }}
                            <span class="meal-detail-font-measure">gr</span>
                        </span>
                    </div>
                    <div class="meal-detail">
                        <span>Carbs:</span>
                        <br />
                        <span class="meal-detail-font">
                            {{ meal.availableCarbohydrate }}
                            <span class="meal-detail-font-measure">gr</span>
                        </span>
                    </div>
                
                
                    <div class="meal-detail">
                        <span>Fats:</span>
                        <br />
                        <span class="meal-detail-font">
                            {{ meal.fat }}
                            <span class="meal-detail-font-measure">gr</span>
                        </span>
                    </div>
                    <!--
                    <div class="meal-detail">
                        <span>Sugar:</span>
                        <br />
                        <span class="meal-detail-font">
                            {{ meal.sugars }}
                            <span class="meal-detail-font-measure">gr</span>
                        </span>
                    </div>
                    -->
                    <div class="meal-detail">
                        <span>Salts:</span>
                        <br />
                        <span class="meal-detail-font">
                            {{ meal.salt }}
                            <span class="plan-detail-font-measure">gr</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-4 d-flex position-relative align-items-center justify-content-center" *ngIf="isCurrentMenu">
            <app-orange-button text="Get Started" (action)="goToOrderFlow()" />
        </div>

        <div class="mt-4 d-flex position-relative align-items-center justify-content-center" *ngIf="!isCurrentMenu">
            <ng-container *ngTemplateOutlet="addRemoveMealButtons"></ng-container>
        </div>
    </div>
</p-dialog>


<ng-template #addRemoveMealButtons>
    <div *ngIf="meal.isAdded && !isCurrentMenu" class="increase-decrease-meal-count-btn">
        <button class="btn btn-dec-ourshop p-0" [style]="(meal.count>1 && !meal.isAdded) || (meal.count>0 && meal.isAdded) ? 'opacity: 1': ''"
            (click)="decreaseCount()"
            style="margin-right: 0.5rem; opacity: 0.3">
            <i class="pi pi-minus weight-700"
                style="padding: 0.5rem; color: #EF870A;"></i>
        </button>
        <span> {{meal.count}} </span>
        <button class="btn btn-primary btn-plus p-0" (click)="increaseCount()"
            style="margin-left: 0.5rem;border-radius: 25px;">
            <i class="pi pi-plus weight-700" style="padding: 0.5rem;"></i>
        </button>
    </div>

    <button class="btn btn-primary weight-700 fm-prompt btn-add-to-cart" *ngIf="!meal.isAdded && !isCurrentMenu" style="width: 100%;font-size: 1rem;" (click)="add()">
        Add
    </button>
</ng-template>